import { motion } from "framer-motion";
import { useTrueAfterDelay } from "../../../hooks/useTrueAfterDelay";

export const delayInitial = 500;
export const delayBetween = 500;

export const AnimateAfterDelay = ({ delay, children, ...props }) => {
  const show = useTrueAfterDelay(true, delay);
  return (
    <motion.div
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: show ? 1 : 0,
        y: show ? 0 : "20px",
      }}
      exit={{ opacity: 0 }}
      {...props}
    >
      {children}
    </motion.div>
  );
};
